import React from 'react';
import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';

import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { Map as ImmutableMap } from 'immutable';

import { FollowButton } from 'mastodon/components/follow_button';
import { IconButton } from 'mastodon/components/icon_button';
import { me } from 'mastodon/initial_state';

import { Avatar } from '../../../components/avatar';
import { DisplayName } from '../../../components/display_name';
import { CloseIcon } from 'mastodon/components/icons/close';

const messages = {
  title: { id: 'status.favourites_list', defaultMessage: '{count} reactions to this post' },
  noFavourites: { id: 'favourites_modal.no_favourites', defaultMessage: 'No one has favorited this post yet.' },
  close: { id: 'bundle_modal_error.close', defaultMessage: 'Close' },
};

const FavouritesModal = ({ accounts, totalCount, onChangeBackgroundColor, onClose }) => {
  const intl = useIntl();
  const displayCount = totalCount ?? accounts.length;

  React.useEffect(() => {
    onChangeBackgroundColor('rgba(0, 0, 0, 0.7)');
    return () => onChangeBackgroundColor(null);
  }, [onChangeBackgroundColor]);

  return (
    <div className={classNames('modal-root__modal', 'favourites-modal')}>
      <div className='favourites-modal-container'>
        <div className='favourites-modal__header'>
          <h3>{intl.formatMessage(messages.title, { count: displayCount })}</h3>
          <IconButton className='favourites-modal__close' title={intl.formatMessage(messages.close)} icon='close' iconComponent={CloseIcon} onClick={onClose} size={20} />
        </div>
        <div className='favourites-modal__content'>
          {accounts.length === 0 ? (
            <p>{intl.formatMessage(messages.noFavourites)}</p>
          ) : (
            <ul className='favourites-modal__list'>
              {accounts.map((account) => {
                const name = account.display_name || account.username || "";

                const displayNameHtml =
                  name.length > 20 ? `${name.substring(0, 17)}...` : name;

                const accountMap = ImmutableMap({
                  ...account,
                  display_name_html: displayNameHtml,
                  roles: account.roles || [],
                });
                return (
                  <li key={account.id} className='favourites-modal__account'>
                    <Link
                      to={`/@${account.acct}`}
                      className='favourites-modal__account-link'
                      onClick={onClose}
                    >
                      <Avatar account={accountMap} size={40} />
                      <DisplayName account={accountMap} />
                    </Link>
                    {account.id !== me && <FollowButton compact accountId={account.id} />}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

FavouritesModal.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    acct: PropTypes.string.isRequired,
  })).isRequired,
  totalCount: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onChangeBackgroundColor: PropTypes.func.isRequired,
};

export default FavouritesModal;
